<template>
  <small  v-if="data"
  
          :class="{
            'error': true,
            'p-error': true,
          }">
    <component  v-if="typeof data == 'object'"
                
                :is="listTag">
      <li v-for="(error, index) in data"

            :key="`error.${index}`">
        <strong> {{ __(error) }} </strong>
      </li>
    </component>
    <strong v-else> {{ __(data) }} </strong>
  </small>
</template>

<script>
export default {
  props: {
    data: {
      default: null, 
      type: [String, Array],
    },
    listTag: {
      type: String,
      default: 'ul',
    },
  }
}
</script>

<style scoped>

  .error {
    display: block;
    font-size: 13px;
    font-weight: bold;
  }

  .error ul {
    margin: 0;
    padding: 0;

    list-style: none;
  }

</style>